export default "__VITE_ASSET__B$AnXU_n__"